import { render, staticRenderFns } from "./informativa-per-la-clientela.vue?vue&type=template&id=264937be"
import script from "./informativa-per-la-clientela.vue?vue&type=script&lang=js"
export * from "./informativa-per-la-clientela.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports